import { createContext, useContext, useState, ReactNode } from "react";
import PartnerForm from "./PartnerForm";

type Ctx = { open: () => void; close: () => void; isOpen: boolean };

const PartnerFormCtx = createContext<Ctx>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export const usePartnerForm = () => useContext(PartnerFormCtx);

export const PartnerFormProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <PartnerFormCtx.Provider
      value={{ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }}
    >
      {children}
      <PartnerForm open={isOpen} onClose={() => setIsOpen(false)} />
    </PartnerFormCtx.Provider>
  );
};
